<template>
    <el-card class="box-card">
        <el-tabs type="border-card">
            <el-tab-pane label="配置重载">
                <div class="component-content">
                    <section class="content">
                        <div class="query-panel">
                            <el-form :inline="true">
                                <el-form-item label="战斗版本:">
                                    <span>{{battleVersion}}</span>
                                    <el-button type="text" @click="getConfigurationDataBattle">导出</el-button>
                                </el-form-item>
                                <el-form-item label="配置表版本:">
                                    <span>{{configVersion}}</span>
                                    <el-button type="text" @click="getConfigurationDataConfig">导出</el-button>
                                </el-form-item>
                            </el-form>

                            <el-form :inline="true">
                                <el-form-item label="上传对比开关:">
                                    <el-switch v-model="isChangeShow" active-text="开" inactive-text="关"></el-switch>
                                    <span class="switch-tip">{{isChangeShow?'':'(当前对比无法展示)'}}</span>
                                </el-form-item>
                            </el-form>

                            <el-form :inline="true">
                                <el-form-item>
                                    <el-upload class="upload-demo" :action="uploadUrl"
                                               :on-change="uploadFile" :auto-upload="false" multiple
                                               :file-list="fileList">
                                        <el-button size="small" type="primary">选择上传文件</el-button>
                                    </el-upload>
                                    <div v-for="(item,index) in resultData" style="" :key="index">
                                        <div :style="{color:item.result?'#606266':'red'}">{{ item.text }}</div>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="fileDataChangeShow = true">批量上传</el-button>
                                </el-form-item>

                                <el-form-item>
                                    <el-button type="danger" @click="reloadConfigClick('all')">重载全部配置
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- 重载配置 -->
                        <el-dialog :visible.sync="reloadConfigShow"
                                   :title="reloadConfigTitle"
                                   width="50%" lock-scroll center>
                            <component-server @worldValue="getWorldValue" :serverMode="'mode_world'" :isClearWorldValue="isClearWorldValue"></component-server>
                            <el-card>
                                <div class="server-title">Login资源</div>
                                <el-table :data="reloadLoginArray" border style="margin-bottom: 20px;">
                                    <el-table-column prop="serverName" label="机器名" width="100">
                                    </el-table-column>
                                    <el-table-column prop="resMsg" label="响应消息" width="100">
                                    </el-table-column>
                                    <el-table-column prop="resStatus" label="响应码" width="100">
                                    </el-table-column>
                                    <el-table-column prop="serverUrl" label="重载请求地址" width="300">
                                    </el-table-column>
                                </el-table>
                            </el-card>

                            <el-card>
                                <div class="server-title">区服</div>
                                <el-table :data="reloadConfigArray" border>
                                    <el-table-column prop="serverName" label="服务器名" width="180">
                                    </el-table-column>
                                    <el-table-column prop="serverNumber" label="编号" width="100">
                                    </el-table-column>
                                    <el-table-column prop="type" label="类型" width="100">
                                    </el-table-column>
                                    <el-table-column prop="resStatus" label="响应码" width="100">
                                    </el-table-column>
                                    <el-table-column prop="resMsg" label="响应消息" width="100">
                                    </el-table-column>
                                    <el-table-column prop="serverUrl" label="重载请求地址" width="350">
                                    </el-table-column>
                                </el-table>
                            </el-card>

                            <div class="query-panel" style="padding: 0 15px 15px;">
                                <div class="reload-other">版本推送状态:
                                    <span :style="{color:pushVersionStatus=='未推送'?'red':'green'}">{{pushVersionStatus}}</span><br/>
                                    <span style="color:red">等待版本推送状态为已推送再关闭此页</span>
                                </div>

                            </div>

                            <div slot="footer" class="dialog-footer">
                                <el-button @click="cancelReload">取消</el-button>
                                <el-button v-if="reloadConfigType == 'all'" type="primary" @click="reloadAllAxios">
                                    确定重载
                                </el-button>
                            </div>
                        </el-dialog>

                        <!-- 上传文件数据改动展示 -->
                        <el-dialog :visible.sync="fileDataChangeShow"
                                   width="50%" lock-scroll center>
                            <el-tabs type="card" @tab-click="handleChangeData" v-if="isChangeShow">
                                <el-tab-pane
                                    :key="item.name"
                                    v-for="(item, index) in fileChangeData"
                                    :label="item.name">
                                    <el-table :data="item.data" border style="width: 100%" :cell-style="cellBgStyle"
                                              :default-sort="{prop: 'id'}">
                                        <el-table-column v-for="(header,index) in fileChangeDataHeaders"
                                                         :label="header.text"
                                                         :prop="header.text"
                                                         :show-overflow-tooltip="true"
                                                         :key="index" width="150">
                                            <!--<template slot-scope="scope">-->
                                                <!--<span @click="isShowChangeDetail = true" type="text" size="small" v-if="(scope.row[header.text].length) > 150">{{isShowChangeDetail?scope.row[header.text]:'查看详情'}}</span>-->
                                                <!--<span v-else>{{scope.row[header.text]}}</span>-->
                                            <!--</template>-->
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>

                            <div slot="footer" class="dialog-footer">
                                <el-button @click="fileDataChangeShow = false">取消</el-button>
                                <el-button @click="uploadAll">确认</el-button>
                            </div>
                        </el-dialog>

                    </section>
                </div>
            </el-tab-pane>
            <el-tab-pane label="数据读取">
                <div class="component-content">
                    <section class="content">
                        <div class="query-panel">
                            <el-form :inline="true">
                                <el-form-item label='表名'>
                                    <el-autocomplete
                                        v-model="tableName"
                                        clearable
                                        :fetch-suggestions="querySearchrConfig"
                                        placeholder='请选择'
                                        @select="handleSelect"
                                    >
                                        <template slot-scope="{ item }">
                                            <span class="addr">{{item.TABLE_NAME}}</span>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="getReadData()">查询表数据</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="getUpdateTime()">查询更新时间</el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                        <template v-if="dataHandled.length > 0">
                            <el-table :data="dataHandled" border style="width: 100%" :cell-style="cellBgStyle"
                                      :default-sort="{prop: 'id'}">
                                <el-table-column v-for="(header,index) in tableHeaders" :label="header.text"
                                                 :prop="header.text"
                                                 :key="index" width="150">
                                    <template slot-scope="scope">
                                        <el-tooltip placement="top-end" v-for="(value,key) in scope.row" :key="key" v-if="key == header.text && ((key == 'gain_base_desc' && tableName == 'origin_footing_stone_config') || (key == 'requirement_desc' && tableName == 'ancient_gene_config') || (key == 'name') || (key == 'description'))">
                                            <div slot="content">{{$t(value)}}</div>
                                            <el-button type="text">{{value}}</el-button>
                                        </el-tooltip>
                                        <span v-for="(value,key) in scope.row" v-if="key == header.text && key !== 'gain_base_desc' && key !== 'requirement_desc' && key !== 'name' && key !== 'description'">{{value}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="pagination">
                                <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                               :page-size="pageSize"
                                               layout="total, prev, pager, next, jumper" :total="totalRow">
                                </el-pagination>
                            </div>
                        </template>

                        <!-- 更新时间弹窗 -->
                        <el-dialog :visible.sync="updateTimeShow" width="50%" lock-scroll center>
                            <el-table :data="versionData" border>
                                <el-table-column prop="id" label='表名'>
                                </el-table-column>
                                <el-table-column prop="tbIdName" label='中文名'>
                                </el-table-column>
                                <el-table-column prop="tbVersion" label='配置表版本' sortable>
                                </el-table-column>
                                <el-table-column prop="updateTime" label='更新时间' sortable>
                                </el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="exportConfigData(scope.row)">导出</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-dialog>
                    </section>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
    import confApi from '../../service/conf_api'
    import confVersionApi from '../../service/conf_version_api'
    import commonApi from '../../service/common_api'
    import worldApi from '../../service/world_api'
    import gameApi from '../../service/game_api'
    import loginApi from '../../service/login_api'
    import beastsApi from '../../service/beasts_api'
    import {
        mapState
    } from 'vuex';
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import axios from 'axios'
    import {
        apis
    } from '../../lib/apis'
    import XLSX from 'xlsx';
    import componentServer from '../../components/component_server'
    import FileSaver from 'file-saver'

    export default {
        name: "config",
        data() {
            return {
                title: this.$route.meta.title,
                // 表明
                tableName: '',
                // 表明选择项
                tableOptions: [],
                // 动态表头
                tableHeaders: [],

                // 显示更新时间
                updateTimeShow: false,
                reloadConfigShow: false,
                reloadConfigArray:[],
                reloadLoginArray:[],
                //reloadConfigData: [],
                reloadConfigTitle: '',
                reloadConfigType: '',

                // 表数据
                tableRawData: [],
                tableTotalRow: '',

                // 显示上传文件列表
                fileList: [],

                // 上传文件列表
                uploadFileLists: [],

                // 上传结果
                resultData: [],

                uploadUrl: apis.conf_upload,

                fileIdx: -1,

                // 上传文件数据改动展示
                fileDataChangeShow: false,
                fileChangeData: [],
                fileChangeDataHeaders: [],
                // 隐藏/显示对比
                isChangeShow: false,
                // 表格展示详情
                isShowChangeDetail: false,

                checkedLogin: true,

                configVersionBO: {
                    changed: []
                },

                // 版本推送状态
                pushVersionStatus: '未推送',

                // 版本数据
                versionData: [],

                isClearWorldValue: false,

                battleVersion: '',
                configVersion: '',

                reloadResultTag : 0

            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverWorldList: state => state.server.serverWorldList,
            }),
        },
        mixins: [paginationController, actionConfirm],
        mounted() {
            this.selectShowTables();
        },
        created() {
            this.loadConfigInfo();
        },
        methods: {
            elChangeExForArray (index1, index2, array) {
                let temp = array[index1]
                array[index1] = array[index2]
                array[index2] = temp
                return array
            },
            // 获取服务器选择
            getWorldValue(val) {
                let self = this;
                self.reloadConfigArray = [];
                let selectedData = [];
                if (val.length === 0) return;
                self.serverWorldList.forEach(item => {
                    val.forEach(item2 => {
                      let selectId = item2 >>0;
                        if (selectId === item.id) {
                            item.type = 'world';
                            selectedData.push(item);
                        }
                    })
                });
                selectedData.forEach(item3 => {
                    console.log('item3',item3);
                    item3.game_servers.forEach(item4 => {
                        item4.type = 'game';
                        selectedData.push(item4)
                    })
                });

                console.log('selectedData',selectedData);
                if (selectedData[0].type !== 'game') {
                    selectedData = this.elChangeExForArray(0,1,selectedData);
                }

                selectedData.forEach(selectedItem => {
                    if (undefined !== selectedItem) {
                        let balanceIps = selectedItem.inner_urls.split(';');
                        if (balanceIps[0] !== '' && balanceIps.length <= 1) {
                            self.reloadConfigArray.push({
                                serverName: selectedItem.server_name,
                                serverNumber: selectedItem.server_number,
                                serverUrl: selectedItem.inner_urls.split(';')[0],
                                type: selectedItem.type,
                                resStatus: 0,
                                resMsg: '未发送'
                            });
                        }

                        balanceIps.shift();
                        if (balanceIps[0] !== '' && balanceIps.length > 0) {
                            balanceIps.forEach(balanceItem => {
                                self.reloadConfigArray.push({
                                    serverName: selectedItem.server_name,
                                    serverNumber: selectedItem.server_number,
                                    serverUrl: balanceItem,
                                    type: selectedItem.type,
                                    resStatus: 0,
                                    resMsg: '未发送'
                                })
                            });
                        }
                    }
                });
            },

            // 读取当前数据
            getReadData() {
                if (this.checkDataEmpty(this.tableName)) {
                    this.$message({
                        type: 'warning',
                        message: '请选择表名'
                    })
                } else {
                    this.tableHeaders = [];
                    confApi.getReadData({
                        token: this.token,
                        tableName: this.tableName
                    }).then(res => {
                        this.rawData = res;
                        this.totalRow = res.length;

                        this.tableRawData = res;
                        this.tableTotalRow = res.length;
                        for (var i in res[0]) {
                            this.tableHeaders.push({
                                text: i
                            });
                        }
                    })
                }
            },

            // 查询配置表以及最新更新时间
            selectShowTables() {
                confApi.selectShowTables(this.token).then(res => {
                    this.tableOptions = res;
                })
            },

            // 查询版本更新
            getAllVersions() {
                confVersionApi.allConfVersions(this.token).then(res => {
                    this.versionData = res;
                })
            },

            // 版本更新
            updateVersionConfig() {
                this.fileChangeData.forEach(item => {
                    if (item.data.length > 0) {
                        this.configVersionBO.changed.push(item.name)
                    }
                })

                if (this.configVersionBO.changed.length > 0) {
                    confVersionApi.updateConfVersion({
                        token: this.token,
                        configVersionBO: this.configVersionBO
                    }).then(res => {
                        this.battleVersion = res.battle_version;
                        this.configVersion = res.config_version;
                        this.$message({
                            type: 'success',
                            message: '版本已成功更新至配置表！(battleVersion='+this.battleVersion + ',configVersion=' + this.configVersion
                        })
                    })
                }
            },

            // 推送当前版本
            pushVersionConfig() {
                confVersionApi.pushConfVersion(this.token).then(res => {
                    this.pushVersionStatus = '已推送';
                    this.$message({
                        type: 'success',
                        message: '版本已推送至oss！'
                    })
                })
            },

            // 查询更新时间
            getUpdateTime() {
                this.updateTimeShow = true;
                this.getAllVersions();
            },
            //展示
            reloadConfigClick(tableName) {
                this.loadConfigInfo();
                this.reloadConfigArray = [];
                this.reloadConfigShow = true;
                this.reloadConfigTitle = "重载全部配置 - " + tableName;
                this.reloadConfigType = tableName;
                this.isClearWorldValue = true;
                this.pushVersionStatus = '未推送';
                setTimeout(() => {
                    this.isClearWorldValue = false;
                },1000)
            },
            cancelReload() {
                this.reloadConfigShow = false;
                this.reloadConfigData = [];
            },

            //重载全部配置
            reloadAllAxios() {
                let self = this;
                let loginPromise = new Promise((loginResolve, loginReject) => {
                    beastsApi.reloadClzName({
                        token: this.token,
                        reloadForm: {
                            reloadTypes:['login'],
                            reloadMode:'2',
                            clzName: '-'
                        }
                    }).then(res => {
                        self.reloadLoginArray = [];
                        res.forEach((item) => {
                            self.reloadLoginArray.push(item);
                        })
                        this.$message({
                            type: 'success',
                            message: ' 登录服重载完毕！'
                        })
                        loginResolve(true);
                    })
                });

                let  zonePromise = ()=>{
                    return new Promise((zoneResolve, reject) => {
                        //let resultArr = [];
                        let zoneCounter = self.reloadConfigArray.length;
                        let reloadServerNumberArray = [];
                        let reloadWorldServerNumberArray = [];

                        self.reloadConfigArray.forEach(item => {
                            if (item.type === 'game'){
                                reloadServerNumberArray.push(item.serverNumber);
                            }else{
                                reloadWorldServerNumberArray.push(item.serverNumber);
                            }
                        })

                        if (reloadServerNumberArray.length > 0 || reloadWorldServerNumberArray.length > 0) {
                            beastsApi.reloadClzName({
                                token: this.token,
                                reloadForm: {
                                    reloadTypes: ['game', 'world'],
                                    gameNumbers: reloadServerNumberArray,
                                    worldNumbers: reloadWorldServerNumberArray,
                                    reloadMode: '2',
                                    clzName: '-'
                                }
                            }).then(res => {
                                self.reloadConfigArray = [];
                                res.forEach((item) => {
                                    self.reloadConfigArray.push(item);
                                })
                                this.$message({
                                    type: 'success',
                                    message: ' 区服重载完毕！'
                                })
                                zoneResolve(true);
                            })
                        }else{
                            zoneResolve(true);
                        }
                    })
                };

                let pushVersionPromise  =()=>{
                    return new Promise(()=>{
                        self.pushVersionConfig();
                    });
                }

                loginPromise = loginPromise.then(zonePromise).then(pushVersionPromise);
            },


            // 上传excel并且更新配置库
            uploadConfExcel() {
                let self = this;
                let formData = new FormData()
                self.fileIdx++;
                var item = self.uploadFileLists[self.fileIdx];
                var fileListLen = self.uploadFileLists.length;

                if (item) formData.append('file', item.raw)
                formData.append('group', 'system')

                const loading = this.$loading({
                    lock: false,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                    customClass: 'loading-box'
                });

                if (self.fileIdx < fileListLen) {
                    if (fileListLen > 0) {
                        axios({
                            method: "post",
                            url: apis.conf_upload_excel + '?token=' + self.token,
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            data: formData
                        }).then(res => {
                            if (res.data.code == 0) {
                                self.resultData.push({
                                    text: item.name + '上传成功',
                                    result: true
                                })
                            } else {
                                self.resultData.push({
                                    text: item.name + '上传失败',
                                    result: false
                                })
                            }
                            self.uploadConfExcel();
                        })
                    }
                }

                if (self.fileIdx >= fileListLen) {
                    self.fileIdx = -1;
                    setTimeout(() => {
                        loading.close();
                        self.$message({
                            type: 'success',
                            message: "上传完毕"
                        })
                    }, 2000)
                    self.updateVersionConfig();
                }
            },

            // 获取文件数据
            uploadFile(file, fileList) {
                const unexportedName = file.name.indexOf('unexported');
                 if (unexportedName == 0) {
                     fileList.forEach((item,index) => {
                         if (item.name == file.name) {
                             fileList.splice(index,1)
                         }
                     })
                }
                this.uploadFileLists = fileList;
                this.readExcel(file)
            },

            // 批量上传(确认上传)
            uploadAll() {
                this.fileList = [];
                this.resultData = [];

                var fileList = this.uploadFileLists;
                if (fileList.length <= 0) {
                    this.$message({
                        type: 'warning',
                        message: '请先上传文件'
                    })
                }

                this.uploadConfExcel();
                this.fileDataChangeShow = false;
            },

            //  处理上传文件变更数据
            handleChangeData(tab, event) {
                var data = this.fileChangeData;
                this.fileChangeDataHeaders = [];
                for (var i in data) {
                    if (data[i].name == tab.label) {
                        for (var i in data[i].data[0]) {
                            if (i !== 'change') {
                                this.fileChangeDataHeaders.push({
                                    text: i
                                });
                            }

                        }
                    }
                }
            },

            // 上传并读取文件
            readExcel(file) {
                const types = file.name.split('.')[1];
                const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types);
                const unexportedName = file.name.indexOf('unexported');

                if (!fileType) {
                    this.$message('格式错误！请重新选择!');
                    return
                } else if (unexportedName == 0) {
                    return
                }
                this.file2Xce(file).then(tabJson => {
                    if (tabJson && tabJson.length > 0) {

                        var data = tabJson[0].sheet;
                        var tableName = tabJson[0].tableName;

                        if (this.isChangeShow) {
                            confApi.getReadData({
                                token: this.token,
                                tableName: tableName
                            }).then(res => {
                                var newData = [];

                                if (res.length > 0) {
                                    res.forEach(resItem => {
                                        for (var i in resItem) {
                                            if (!isNaN(Number(resItem[i]))) {
                                                resItem[i] = Number(resItem[i]);
                                            }
                                        }
                                    })

                                    data.forEach((item, index) => {
                                        res.forEach(item2 => {
                                            if (item.id == item2.id) {
                                                for (var i in item) {
                                                    if (item[i]!== item2[i]) {
                                                        item.change = (item.change ? item.change + ',' : '') + i;

                                                        newData.push(item)

                                                        for (var i = 0; i < newData.length - 1; i++) {
                                                            for (var j = i + 1; j < newData.length; j++) {
                                                                if (newData[i].id == newData[j].id) {
                                                                    newData.splice(j, 1);
                                                                    j--;
                                                                }
                                                            }
                                                        }

                                                        res.forEach((item3, index) => {
                                                            newData.forEach(item4 => {
                                                                if (item3.id == item4.id) {
                                                                    item3.change = 'grey'
                                                                    newData.push(item3)
                                                                }
                                                            })
                                                        })
                                                    }
                                                }
                                            }
                                        })
                                    })
                                }


                                var indexArr = [];
                                data.forEach((item5, index) => {
                                    indexArr.push(item5.id >> 0)
                                })

                                var indexArr2 = [];
                                res.forEach((item6, index) => {
                                    indexArr2.push(item6.id)
                                })

                                data.forEach(item7 => {
                                    if (!indexArr2.includes(item7.id >> 0)) {
                                        item7.change = 'add'
                                        newData.push(item7)
                                    }
                                })

                                res.forEach(item8 => {
                                    if (!indexArr.includes(item8.id)) {
                                        item8.change = 'del'
                                        newData.push(item8)
                                    }
                                })

                                this.fileChangeData.push({
                                    name: tableName,
                                    data: newData
                                })

                                this.fileChangeDataHeaders = [];
                                for (var i in this.fileChangeData[0].data[0]) {
                                    if (i !== 'change') {
                                        this.fileChangeDataHeaders.push({
                                            text: i
                                        });
                                    }

                                }
                            })
                        } else {
                            this.configVersionBO.changed.push(tableName)
                        }
                    }
                })
            },
            file2Xce(file) {
                return new Promise(function (resolve, reject) {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        const data = e.target.result;
                        this.wb = XLSX.read(data, {
                            type: 'binary'
                        })
                        const result = [];
                        var endChar = '';
                        var endNum = '';
                        this.wb.SheetNames.forEach((sheetName) => {
                            for (var i in this.wb.Sheets[sheetName]) {
                                if (i.replace(/[a-z]/ig, '') === '3') {
                                    endChar = i.split('3')[0];
                                }

                                if (this.wb.Sheets[sheetName][i]['v'] === 'END') {
                                    endNum = i.replace(/[a-z]/ig, '');
                                }
                            }

                            // this.wb.Sheets[sheetName]['!ref'] = "B3:" + this.wb.Sheets[sheetName]['!ref'].split(':')[1];
                            this.wb.Sheets[sheetName]['!ref'] = "B3:" + endChar + endNum;
                            var tableName = this.wb.Sheets[sheetName]['A1']['v'];
                            result.push({
                                tableName: tableName,
                                sheetName: sheetName,
                                sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
                            })
                        })
                        resolve(result)
                    }
                    reader.readAsBinaryString(file.raw)
                })
            },

            cellBgStyle({row, column, rowIndex, columnIndex}) {
                if (row.change) {
                    var dataArr = row.change.split(',')
                    for (var i in dataArr) {
                        if (dataArr[i] === column.label) {
                            return {
                                background: '#f56c6c'
                            }
                        }
                    }

                    if (row.change === 'add') {
                        return {
                            background: '#2ea44f'
                        }
                    } else if (row.change === 'del') {
                        return {
                            background: '#f56c6c'
                        }
                    } else if (row.change === 'grey') {
                        return {
                            background: '#e9e9e9'
                        }
                    }
                }
            },

            loadConfigInfo(){
                let self = this;
                commonApi.getConfs({
                        tables: 'configuration,yunwei_server_config'
                }).then(res => {
                    res.configuration.forEach(item => {
                        // 获取战斗版本和配置表版本
                        switch (item.key_name){
                            case 'battle_version': {
                                self.battleVersion = item.key_value;
                                break;
                            }
                            case 'config_version':{
                                    self.configVersion = item.key_value;
                                    break;
                            }
                            default:
                                break
                        }
                    })

                    self.reloadLoginArray = [];
                    res.yunwei_server_config.forEach(item => {
                        if (item.server_type == 'login') {
                            self.reloadLoginArray.push({
                                serverUrl: item.server_url,
                                type: item.server_type,
                                serverName: item.server_name,
                                resStatus: 0,
                                resMsg: '未发送',
                            })
                        }
                    })
                })
            },

            // 获取前端配置数据-战斗
            getConfigurationDataBattle() {
                commonApi.findConfigurationByKey({
                    token: this.token,
                    configurationKey: 'battle_data'
                }).then(res => {
                    var data = res.value;
                    var data2 = res.value2;
                    const blob = new Blob([data], {type: 'application/json'});
                    FileSaver.saveAs(blob, 'config-' + data2 + '.json');
                });
            },
            // 获取前端配置数据-配置
            getConfigurationDataConfig() {
                commonApi.findConfigurationByKey({
                    token: this.token,
                    configurationKey: 'config_data'
                }).then(res => {
                    var data = res.value;
                    var data2 = res.value2;
                    const blob = new Blob([data], {type: 'application/json'});
                    FileSaver.saveAs(blob, data2 + '.conf');
                });
            },

            querySearchrConfig(queryString, cb) {
                var data = this.tableOptions;
                var results = queryString ? data.filter(this.createFilter(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilter(queryString) {
                return (data) => {
                    return (data.TABLE_NAME.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.tableName = item.TABLE_NAME;
            },

            // 导出配置表数据
            exportConfigData(data) {
                var self = this;
                var tableName = data.id;
                var tbIdName = data.tbIdName;
                confApi.getReadData({
                    token: self.token,
                    tableName: tableName
                }).then(res => {
                    var arr = [
                        [tableName]
                    ];
                    var arr1 = ["客户端"];
                    var arr2 = ["服务端"];
                    var keyArr = [];

                    for (var i in res[0]) {
                        arr1.push(i);
                        arr2.push(i);
                        keyArr.push(i);
                    }
                    arr.push(arr1);
                    arr.push(arr2);

                    res.forEach((item,index) => {
                        var _arr = [];
                        if (res.length-1 == index) {
                            _arr = ['END'];
                            keyArr.forEach(keyItem => {
                                _arr.push(item[keyItem].toString());
                            })
                        } else {
                            _arr = [''];
                            keyArr.forEach(keyItem => {
                                _arr.push(item[keyItem].toString());
                            })
                        }
                        arr.push(_arr);
                    })

                    const ws= XLSX.utils.aoa_to_sheet(arr);
                    const wb = XLSX.utils.book_new();

                    var tableNameArr = tableName.split('_');
                    var sheetName = '';
                    tableNameArr.forEach(item => {
                        sheetName += item.slice(0,1).toUpperCase() + item.slice(1).toLowerCase();
                    })

                    XLSX.utils.book_append_sheet(wb, ws, sheetName);

                    XLSX.writeFile(wb, sheetName + tbIdName + '.xlsx');
                })
            },
        },
        components: {
            componentServer
        }
    }
</script>

<style scoped lang="less">
    .reload-other {
        margin-top: 20px;
        font-weight: bold;
    }

    .switch-tip {
        color: red;
    }

    .server-title {
        margin-bottom: 10px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/views/plot_tools/config.vue